var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,13.48h-3V7.48h3v6Zm0,4.5h-3v-3h3v3Zm10.08,.75L13.31,.75c-.14-.23-.33-.42-.56-.55-.23-.13-.48-.2-.75-.2s-.52,.07-.75,.2c-.23,.13-.42,.32-.56,.55L.42,18.73c-.13,.23-.19,.48-.19,.75s.06,.52,.19,.75c.14,.23,.33,.42,.56,.55,.23,.13,.48,.2,.75,.2H22.27c.27,0,.52-.07,.75-.2,.23-.13,.42-.32,.56-.55,.12-.23,.19-.48,.19-.75s-.06-.52-.19-.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssues);
export default __webpack_public_path__ + "static/media/issues.f5af5c9748e3dfddc08c25cb53438125.svg";
export { ForwardRef as ReactComponent };